// extracted by mini-css-extract-plugin
export default {"form-section":"form-section_form-section__r0F3T","form-section__title":"form-section_form-section__title__f+T2J","form-section__content":"form-section_form-section__content__zsLg8"};